import React from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { FormProvider, useForm } from "react-hook-form";

import {
  PaziaFormButton,
  PaziaInput,
  PaziaSwitch,
  PaziaTextarea,
} from "components/atoms";
import { SurveyApi } from "api/surveyApi";

interface SurveyFormProps {
  survey?: SurveyApi;
  onSubmit: (data: SurveyFormValues) => void;
}
export const SurveyForm = ({ survey, onSubmit }: SurveyFormProps) => {
  const methods = useForm<SurveyFormValues>({
    resolver: yupResolver(schema),
    defaultValues: {
      [SURVEY_FORM_FIELDS.NAME]: survey?.name,
      [SURVEY_FORM_FIELDS.DESCRIPTION]: survey?.description,
      [SURVEY_FORM_FIELDS.IS_END_COURSE]: survey?.isEndCourse ?? false,
    },
  });
  const { handleSubmit } = methods;

  return (
    <div className="xl:w-1/3 lg:w-1/2">
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-2">
          <PaziaInput required label="Nazwa" name={SURVEY_FORM_FIELDS.NAME} />
          <PaziaTextarea label="Opis" name={SURVEY_FORM_FIELDS.DESCRIPTION} />
          <PaziaSwitch label="Ankieta końcowa kursu" name={SURVEY_FORM_FIELDS.IS_END_COURSE} />
          <div className="flex justify-end">
            <PaziaFormButton title="Zapisz" type="success" />
          </div>
        </form>
      </FormProvider>
    </div>
  );
};

const SURVEY_FORM_FIELDS = {
  NAME: "name",
  DESCRIPTION: "description",
  IS_END_COURSE: "isEndCourse",
} as const;

const schema = yup
  .object({
    [SURVEY_FORM_FIELDS.NAME]: yup.string().required(),
    [SURVEY_FORM_FIELDS.DESCRIPTION]: yup.string(),
    [SURVEY_FORM_FIELDS.IS_END_COURSE]: yup.boolean().required(),
  })
  .required();

export type SurveyFormValues = yup.InferType<typeof schema>;
